import React, { FC } from 'react'
import { IconButton } from '@wmgtech/legato'
import { EditButtonsProps, ViewButtonsProps } from './action-button.props'
import styles from './action-button.module.scss'

export const EditMode: FC<EditButtonsProps> = ({ onCancel, onSubmit }) => {
  return (
    <div className={styles.container}>
      <IconButton message="Cancel Edit" className={styles.btn} colorType="danger" icon="xmark" onClick={onCancel} />
      <IconButton message="Save" colorType="success" icon="check" className={styles.btn} onClick={onSubmit} />
    </div>
  )
}

export const ViewMode: FC<ViewButtonsProps> = ({ onDelete, onEdit }) => {
  return (
    <div className={styles.container}>
      <IconButton message="Edit" className={styles.btn} colorType="success" icon="pencil" onClick={onEdit} />
      <IconButton message="Delete" colorType="danger" icon="trash-can" className={styles.btn} onClick={onDelete} />
    </div>
  )
}
